import { SetupFreespinsCommand } from 'commands/setup-freespins-command';
import bonusBuyComponent from 'components/bonus-buy/bonus-buy-component';
import { JumpstartSpinCommand } from 'slotworks/commands/comms/jumpstart-spin-command';
import HidePromoFSonFreespins from 'slotworks/commands/promo-free-spins/hide-pfs-on-freespins';
import { BetBarType } from 'slotworks/components/betbar/bet-bar-component';
import Components from 'slotworks/components/components';
import Layers from 'slotworks/graphics/layers/layers';
import Translations from 'slotworks/i18n/translations';
import loader from 'slotworks/loader/loader';
import BetMenuFreespinsMediator from 'slotworks/mediators/bet-menu-freespins-mediator';
import betModel from 'slotworks/model/bets/bet-model';
import GameState from 'slotworks/model/game-state';
import settingsModel from 'slotworks/model/settings/settings-model';
import smartButton, { SmartButtonFlag } from 'slotworks/smart-button/smart-button';
import soundManager from 'slotworks/sound/sound-manager';
import EnterRecoveryFreespins from 'slotworks/state-machine/standard/states/enter-recovery-freespins';
import { parallel } from 'slotworks/utils/race-utils';
import PortraitMessages from 'components/messages/portrait-messages';
import WildSticky from './wild-sitcky';
import regulation from 'slotworks/integration/revolver/regulations/regulation';
import { GlowFilter } from 'pixi-filters';

export default class RecoverFreeSpin extends EnterRecoveryFreespins {
    public onEnter() {
        loader.loadStage(3).then(() => {
            Components.betBar.setBetOptions(betModel.generateBetOptions());
            Components.betBar.setType(BetBarType.FREESPINS);
            SetupFreespinsCommand().execute();
            WildSticky.onEnterFreespins();
            bonusBuyComponent.hide();
            regulation.interactionStart();
            this.enter();
        });
    }

    private enter() {
        const gameplay = GameState.getCurrentGame();
        HidePromoFSonFreespins();
        smartButton.setFlag(SmartButtonFlag.FREE_SPINS, true);
        
        new BetMenuFreespinsMediator().start().execute();

        Components.betBar.winnings.setWinnings(0, gameplay.getRunningFreespinsWinTotal() - gameplay.getCurrentRecord().creditsWon);
        const homeButton = Layers.BetBar.getFlexiButton('home');
        const homeURL = settingsModel.homeURL;
        if (homeButton) {
            if (homeURL === 'close' || homeURL === '' || homeURL === undefined || homeURL === null) {
                homeButton.setVisible(false);
            } else {
                homeButton.setVisible(true);
            }
        }
        Components.betBar.setEnabled(false);
        this.recoverFreespinsElements();

        const contents = new Map<string, string>();
        contents.set('body', Translations.get('rec.fre'));
        parallel([() => JumpstartSpinCommand(), () => Components.prompt.show(['info', 'error'], contents)]).then(() => {            
            soundManager.customEvent("starts_freespin");    
            PortraitMessages.setFreespins();

            const value = Layers.BetBar.getText("freespins_x_of_y_value");
            if(value) {
                value.filters = [ new GlowFilter(3, 3, 0, 0x1c4aba)];
            }
            
            this.complete();
        });
    }
}



// WEBPACK FOOTER //
// ./src/states/recover-freespin.ts